
import { AuthEffects } from './auth.effect';

export * from './auth.effect';

export const effects = [AuthEffects];
